import React from 'react'
import CV from './CV'
import ImageGrid from './ImageGrid'
import ProfileInfo from './ProfileInfo'
import {Video} from '../components/Video'

import Lightbox from './Lightbox'
// import profile from './data'

import './profile.scss'
// import { Tabs, Tab } from 'react-blazecss'

import { nameOf } from './utils'

const host = REST_API// "http://localhost:8080"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
const baseUrl = host + "/api/files"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
import { SocialButtons } from '../components/SocialButtons'

const DoubleBorder = ({borderColor="black"}) => (
  <div style={{height: 6, flexGrow: 1}}>
    <div style={{height: 6, borderTop: '1px solid black', boxSizing: 'content-box', borderBottom: '1px solid black', borderColor }}></div>
  </div>
)

const Title = ({id, component="h1", style={}, className, children}) => {
  const Component = component
  return (
    <div id={id} className={className} style={{ marginTop: 0, marginBottom: 10, textAlign: 'center', display: 'flex', alignItems: 'center', flexWrap: 'nowrap'}}>
      <DoubleBorder borderColor="#e5e5e5" />
      <Component style={{
        padding: '0 45px',
        margin: 0,
        ...style
      }}>
        {children}
      </Component>
      <DoubleBorder borderColor="#e5e5e5" />
    </div>
  )
}



export class ProfilePage extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      isOpen: false,
      currentImage: 0
    }

    this.openLightbox = (idx) => {
      this.setState({
        isOpen: true,
        currentImage: idx
      })
    }
    
    this.gotoPrevLightboxImage = () => this.setState({ currentImage: this.state.currentImage-1})
    this.gotoNextLightboxImage = () => this.setState({ currentImage: this.state.currentImage+1})
    this.gotoLightboxImage = (index) => this.setState({ currentImage: index})
    this.closeLightbox = () => this.setState({ isOpen: false })
  }

  render() {
    const { profile={}, isPDF } = this.props
    const { isOpen, currentImage } = this.state

    const { categories=[], videos=[], portfolio=[] } = profile 
    const name = nameOf(profile);

    return (
      <div className="post-content">
        <SocialButtons twitterText={name} hashtags="cjtalents" />
        <div className="fusion-fullwidth fullwidth-box fusion-fullwidth-1  fusion-parallax-none nonhundred-percent-fullwidth" style={{ borderColor: '#eae9e9', borderBottomWidth: 0, borderTopWidth: 0, borderBottomStyle: 'solid', borderTopStyle: 'solid', paddingBottom: 0, paddingTop: 20, backgroundColor: 'rgba(255,255,255,0)', }}>
          <div className="fusion-row">
            <Title style={{ fontSize: 33.95, lineHeight: '60.14px', fontWeight: 'bold', textTransform: 'uppercase'}}>{name}</Title>
            <h2 style={{ textAlign: 'center', fontSize: 33.95, lineHeight: '60.14px', color: ' #999999', marginBottom: 20}}>{categories.map(cat => cat.label).join(", ")}</h2>
          </div></div><div className="fusion-fullwidth fullwidth-box fusion-fullwidth-2  fusion-parallax-none nonhundred-percent-fullwidth" style={{ borderColor: '#eae9e9', borderBottomWidth: 0, borderTopWidth: 0, borderBottomStyle: 'solid', borderTopStyle: 'solid', paddingBottom: 0, paddingTop: 20, backgroundColor: 'rgba(255,255,255,0)', }}>
          
          <ProfileInfo profile={profile} isPDF={isPDF} onProfileImageClick={() => this.openLightbox(0)} />
          {/*<ProfileInfo profile={profile} isPDF={isPDF} />*/}
                
      </div>      
                
      <div className="fusion-fullwidth fullwidth-box fusion-fullwidth-1  fusion-parallax-none nonhundred-percent-fullwidth" style={{ borderColor: '#eae9e9', borderBottomWidth: 0, borderTopWidth: 0, borderBottomStyle: 'solid', borderTopStyle: 'solid', paddingBottom: 0, paddingTop: 20, backgroundColor: 'rgba(255,255,255,0)', }}>
        <div className="fusion-row">
          <Title component="h2" style={{ fontSize: 33.95, lineHeight: '60.14px' }}>Portfolio</Title>
          <ImageGrid images={portfolio} onClick={(idx) => this.openLightbox(idx+1)}/>
        </div>
      </div>

      {videos.length > 0 
        ? (<div className="fusion-fullwidth fullwidth-box fusion-fullwidth-1  fusion-parallax-none nonhundred-percent-fullwidth"
          style={{
            pageBreakBefore:'always',
            borderColor: '#eae9e9',
            borderBottomWidth: 0,
            borderTopWidth: 0,
            borderBottomStyle: 'solid',
            borderTopStyle: 'solid',
            paddingBottom: 0, paddingTop: 20,
            backgroundColor: 'rgba(255,255,255,0)'
          }}>
          <div className="fusion-row" style={{display: 'inline-block', width: '100%'}}>
            <Title id="videos" component="h2" style={{ fontSize: 33.95, lineHeight: '60.14px' }}>{videos.length == 1 ? "Vidéo" : "Vidéos"}</Title>
            <center>
              <div className="fusion-video fusion-youtube" style={{ maxWidth: 600, maxHeight: isPDF ? undefined : 350 }}>
                <Video url={profile.videos[0].url} />
              </div>
            </center>
          </div>
        </div>)
      : null
      }

        <Lightbox
          images={[profile.profileImage, ...(portfolio || [])].map(img => ({
            src: baseUrl + "/" + img.id,
            thumbnail: baseUrl + "/" + img.id + "/thumbnail?w=50&h=50&auto&minScale=0.75"
          }))}
          isOpen={isOpen}
          currentImage={currentImage}
          backdropClosesModal={false}
          onClickPrev={this.gotoPrevLightboxImage}
          onClickNext={this.gotoNextLightboxImage}
          onClickThumbnail={this.gotoLightboxImage}
          onClose={this.closeLightbox}
          showThumbnails={true}
          thumbnailOffset={8}
        />

        <div className="fusion-fullwidth fullwidth-box fusion-fullwidth-1  fusion-parallax-none nonhundred-percent-fullwidth" style={{ borderColor: '#eae9e9', borderBottomWidth: 0, borderTopWidth: 0, borderBottomStyle: 'solid', borderTopStyle: 'solid', paddingBottom: 0, paddingTop: 20, backgroundColor: 'rgba(255,255,255,0)', }}><div className="fusion-row"><div className="fusion-menu-anchor" id="CV"></div>
          <Title id="CV" component="h2" style={{ fontSize: 33.95, lineHeight: '60.14px' }}>CV</Title>
          <CV data={profile.cv} showDate={profile.showDate}/>
        </div></div>
      </div>

    )
  }
}





export * from './PDFProfile'



/** WEBPACK FOOTER **
 ** ./src/profile/index.js
 **/